export const TransactionStore = new Map();
export const BlockStore = new Map();
